import { Registration } from '../../registration/registration.model';
import { Payment } from '../payment.model';

export enum PaymentType {
  STRIPE = 'stripe',
  ONFACT = 'onfact',
  PONTO = 'ponto',
}

export enum PaymentStatus {
  PENDING = 'pending',
  EXPIRED = 'expired',
  PAID = 'paid',
  FAILED = 'failed',
  IN_PROGRESS = 'in_progress',
  CANCELLED = 'cancelled',
}

export enum CheckoutOutcome {
  CANCELLED = 'cancelled',
  SUCCESS = 'success',
}

export enum PaymentReason {
  Order = 'order',
  RegistrationReimbursement = 'registrationReimbursement',
  Wage = 'wage',
  ExpenseNote = 'expenseNote',
  DiscountReimbursement = 'discountReimbursement',
}

export interface Order {
  type: PaymentType;
  payment: Payment;
  registrations: Registration[];
}

export type PaymentReferences = {
  [T in PaymentType]: {
    [PaymentType.STRIPE]: { id: string; paymentUrl: string };
    [PaymentType.PONTO]: string;
    [PaymentType.ONFACT]: {
      id: string;
      number: string;
      remittance: string;
      journalId: number;
    };
  }[T];
};

export interface DiscountInformation {
  code: string;
  reduction: number;
}

export interface AppliedDiscount {
  code: string;
}

export interface PaymentInformation {
  id: string;
  itemTotal: number;
  total: number;
  description: string;
  discount?: DiscountInformation;
}

export type RegistrationPayment =
  | {
      price: number;
      fullPrice: undefined;
      appliedDiscount: undefined;
    }
  | {
      price: number;
      fullPrice: number;
      appliedDiscount: AppliedDiscount;
    };

export interface Invoice {
  id: string;
  number: string;
}
